import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, Typography, SxProps, Theme } from '@mui/material';

const QUESTION_STRINGS = appStrings.modules.solutionSessions.questions;

type EnterButtonProps = Readonly<{
  id?: string;
  onClick: () => void;
  label: string;
  showEnterHint?: boolean;
  disabled?: boolean;
}>;

export const EnterButton = ({
  id = 'lubav-enter-button',
  onClick,
  label,
  showEnterHint = false,
  disabled = false,
}: EnterButtonProps) => {
  return (
    <Box sx={buttonContainerStyle}>
      <Button
        id={id}
        onClick={onClick}
        hierarchy="Primary"
        size="sm"
        disabled={disabled}
        sx={buttonSx}
      >
        {label}
      </Button>
      {showEnterHint && (
        <Typography variant="text-xs-regular" color={({ backrs }) => backrs.colors['Gray/500']}>
          {QUESTION_STRINGS.press} <strong>{QUESTION_STRINGS.enter}</strong>
        </Typography>
      )}
    </Box>
  );
};

const buttonSx: SxProps<Theme> = ({ backrs, typography }) => ({
  padding: `${backrs.spacing['spacing-xs']} ${backrs.spacing['spacing-md']}`,
  marginRight: backrs.spacing['spacing-md'],
  ...typography['text-sm-semibold'],
});

const buttonContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
};
